export const isLoadingSchema = (state) => state.isLoadingSchema
export const listSchema = (state) => state.listSchema
export const currentSelection = (state) => state.currentSelection
export const currentSchema = (state) => state.currentSchema
export const action = (state) => state.action
export const layerTree = (state) => state.layerTree



// WEBPACK FOOTER //
// ./src/store/modules/schemaFonctionnel/getters.js